function initSelectBook(element) {
	new Autocomplete(element, {
		threshold: 0,
		label: 'value',
		value: 'value',
		data: window[element.dataset.selectBookData],
		maximumItems: 500,
	});
}

document.addEventListener("DOMContentLoaded", function() {
	naja.initialize();

	if(window.selectBook) {
		window.selectBook.forEach((bookElementId) => {
			initSelectBook(document.getElementById(bookElementId));
		});
	}
});